import React from 'react';
import { Helmet } from 'react-helmet';
import Template from '../components/templates/default';
import Main from '../containers/Main';
import UserNotAllowed from '../components/organisms/userNotAllowed';

const UserNotAllowedPage = () => {
  const pageTitle = 'Erro - Esse usuário já Existe - Experimente';
  return (
    <Template className="user-not-allowed-page">
      <Helmet title={pageTitle} />
      <Main pageTitle={pageTitle}>
        <UserNotAllowed />
      </Main>
    </Template>
  );
};

export default UserNotAllowedPage;
